<template>
<div id="home">
  <main role="main">
    <div class="top-image">
      <div class="top-text">
        <h1>Create the BEST.</h1>
      </div>
    </div>
    <div class="top-message">
      <span>「顧客にとって、従業員にとって、社会にとって、最高のモノを創る。」それが、ビットハイブのミッションです。</span>
    </div>
    <div class="section-title">
      <div class="en">
        <span>SERVICE</span>
      </div>
      <div class="jp">
        <span>事業内容</span>
      </div>
    </div>
    <section id="finance">
      <div class="finance-image">
        <div class="finance-text">
          <h1>証券（リテール）システム開発支援</h1>
        </div>
      </div>
      <div class="inner">
        <h2 class="h2-has-icon">証券（リテール）システム開発支援</h2>
        <p>
          <span>株式やデリバティブ商品の取引システム開発を行うお客様を支援するサービスです。</span>
          <span class="br"/>
          <span class="br">取引ツール（HTML5 SAP、Native App、iOS/Android）からフロントシステム、ディーリングシステム、分析システム等の開発を請負・準委任でサポートいたします。</span>
        </p>
        <div class="button-wrapper">
          <router-link class="button" :to="{ name: 'contact', params: {
            value: 'contact',
            from: 'home-finance',
          }}"><span>CONTACT US</span></router-link>
        </div>
      </div>
    </section>
    <section id="web-create">
      <div class="web-create-image">
      </div>
      <div class="inner">
        <h2 class="h2-has-icon">Webサイト開発</h2>
        <p>
          <span>最新のWebデザイン・Webテクノロジーから、Webシステム構築・運用保守まで、Webの事なら当社にお任せください。</span>
        </p>
        <div class="button-wrapper">
          <router-link class="button" :to="{ name: 'contact', params: {
            value: 'contact',
            from: 'home-web-create',
          }}"><span>CONTACT US</span></router-link>
        </div>
      </div>
    </section>
  </main>
</div>
</template>

<script>
export default {
  name: 'Home',
  mounted () {
    if (this.$route.params.value != null) {
      document.getElementById(this.$route.params.value).scrollIntoView()
      window.scrollBy(0, -58)
    }
  }
}
</script>

<style lang="scss">
@import "../assets/style/global.scss";
#home {
  letter-spacing: .15em;
  line-height: 30px;
  > main {
    color: #333333;
    background-color: #f3f3f3;
    > .top-image {
      padding-top: 42%;
      position: relative;
      background-image: url("../assets/img/top.png");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 100%;
      height: auto;
      margin: 0 auto;
      > .top-text {
        @media screen and (max-width: 1024px) {
          margin-top: -40px;
        }
        @media screen and (min-width: 1025px) {
          margin-top: -60px;
        }
        font-weight: 700;
        color: #ffffff;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        > h1 {
          @media screen and (max-width: 1024px) {
            font-size: 28px;
            letter-spacing: .03em;
            line-height: 1.7;
          }
          @media screen and (min-width: 1025px) {
            font-size: 48px;
            letter-spacing: .045em;
            line-height: 1.55;
            font-weight: 600;
          }
        }
      }
    }
    > .top-message {
      @media screen and (max-width: 1024px) {
        padding: 37px 20px;
        font-size: 14px;
      }
      @media screen and (min-width: 1025px) {
        padding: 37px 70px;
        font-size: 16px;
      }
      text-align: justify;
      text-justify: inter-ideograph;
      padding: 20px;
    }
    > .section-title {
      padding: 10px 70px 40px 70px;
      text-align: center;
      > .en {
        line-height: 1.4;
        font-weight: 700;
        @media screen and (max-width: 1024px) {
          font-size: 24px;
        }
        @media screen and (min-width: 1025px) {
          font-size: 36px;
        }
      }
      > .jp {
        @media screen and (max-width: 1024px) {
          font-size: 10px;
        }
        @media screen and (min-width: 1025px) {
          font-size: 13px;
        }
      }
    }
    #finance, #web-create {
      .finance-image {
        background-image: url("../assets/img/finance.png");
      }
      .web-create-image {
        background-image: url("../assets/img/webcreate.png");
      }
      .finance-image, .web-create-image {
        padding-top: 42%;
        position: relative;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 100%;
        height: auto;
        margin: 0 auto;
        .finance-text {
          @media screen and (max-width: 512px) {
            margin-top: -25px !important;
          }
          @media screen and (max-width: 1024px) {
            margin-top: -40px;
          }
          @media screen and (min-width: 1025px) {
            margin-top: -60px;
          }
          font-weight: 700;
          color: #ffffff;
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          > h1 {
            @media screen and (max-width: 512px) {
              font-size: 18px !important;
              letter-spacing: .03em;
              line-height: 1.7;
            }
            @media screen and (max-width: 1024px) {
              font-size: 28px;
              letter-spacing: .03em;
              line-height: 1.7;
            }
            @media screen and (min-width: 1025px) {
              font-size: 48px;
              letter-spacing: .045em;
              line-height: 1.55;
              font-weight: 600;
            }
          }
        }
      }
      > .inner {
        @media screen and (max-width: 1024px) {
          padding: 37px 20px;
          font-size: 14px;
        }
        @media screen and (min-width: 1025px) {
          padding: 37px 70px;
          font-size: 16px;
        }
        > .h2-has-icon {
          margin-top: 0px;
          margin-bottom: 25px;
          padding: 80px 0 0;
          border: none;
          text-align: center;
          color: #444;
          font-size: 20px;
          font-weight: 600;
          letter-spacing: .12em;
          background: url(../assets/img/powerpoint.svg) center top no-repeat;
          background-size: 58px auto;
        }
        > p {
          line-height: 2em;
          margin-bottom: 2.9em;
          letter-spacing: .02em;
        }
        .button-wrapper {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          margin-bottom: 62px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue